import { HTTP_REQUEST_METHOD } from './http-request-types.constant';
import { UrlConfig } from '../models';

export const SERVICE_CONFIG = {
  auth: new UrlConfig('/process/{{processType}}/as/{{oneTimeToken}}', HTTP_REQUEST_METHOD.POST),
  scenario: {
    startScenarioStep: new UrlConfig(
      '/process/scenario/startScenarioStep/{{scenarioId}}',
      HTTP_REQUEST_METHOD.POST
    ),
    sendNotification: new UrlConfig(
      '/process/scenario/sendNotification/{{scenarioId}}',
      HTTP_REQUEST_METHOD.POST
    ),
    getScenarios: new UrlConfig('/process/scenario/V2/scenario'),
    endTransaction: new UrlConfig('/process/scenario/endTransaction', HTTP_REQUEST_METHOD.POST),
    redirectCanBeExecuted: new UrlConfig('/process/scenario/redirect/can-be-executed'),
    // getMockedScenarios: new UrlConfig('/process/scenario/scenarioMockData'),
  },
  agreement: {
    prepareScenarioAgreements: new UrlConfig(
      '/process/scenario/agreements/prepareScenarioAgreements/{{scenarioId}}'
    ),
    acceptScenarioAgreements: new UrlConfig(
      '/process/scenario/agreements/acceptScenarioAgreements/',
      HTTP_REQUEST_METHOD.POST
    ),
  },
  phoneVerifier: {
    getToken: new UrlConfig('/process/phone-verifier/v2/token', HTTP_REQUEST_METHOD.GET, true),
    validateToken: new UrlConfig(
      '/process/phone-verifier/token/validation',
      HTTP_REQUEST_METHOD.POST,
      true
    ),
    cancel: new UrlConfig(
      '/process/phone-verifier/transaction/cancellation',
      HTTP_REQUEST_METHOD.POST,
      true
    ),
  },
  phoneVerifierOTP: {
    getToken: new UrlConfig('/process/phone-verifier-otp/token', HTTP_REQUEST_METHOD.GET, true),
    validateToken: new UrlConfig(
      '/process/phone-verifier-otp/token/validation',
      HTTP_REQUEST_METHOD.POST,
      true
    ),
    cancel: new UrlConfig(
      '/process/phone-verifier-otp/transaction/cancellation',
      HTTP_REQUEST_METHOD.POST,
      true
    ),
    regenerateToken: new UrlConfig(
      '/process/phone-verifier-otp/token/regeneration',
      HTTP_REQUEST_METHOD.POST,
      true
    ),
  },
  mObywatel: {
    deepLink: new UrlConfig('/process/mobywatel/deep-link', HTTP_REQUEST_METHOD.GET, true),
    getToken: new UrlConfig('/process/mobywatel/token', HTTP_REQUEST_METHOD.GET, true),
    getStatus: new UrlConfig('/process/mobywatel/status', HTTP_REQUEST_METHOD.GET, true),
    cancel: new UrlConfig('/process/mobywatel/cancelation', HTTP_REQUEST_METHOD.POST, true),
  },
  edoApp: {
    deepLink: new UrlConfig('/process/edo/deep-link', HTTP_REQUEST_METHOD.GET, true),
    getToken: new UrlConfig('/process/edo/token', HTTP_REQUEST_METHOD.GET, true),
    getStatus: new UrlConfig('/process/edo/status', HTTP_REQUEST_METHOD.GET, true),
    cancel: new UrlConfig('/process/edo/cancelation', HTTP_REQUEST_METHOD.POST, true),
  },
  freeSignatures: {
    deepLink: new UrlConfig('/process/free-signatures/deep-link', HTTP_REQUEST_METHOD.GET, true),
    getToken: new UrlConfig('/process/free-signatures/token', HTTP_REQUEST_METHOD.GET, true),
    getStatus: new UrlConfig('/process/free-signatures/status', HTTP_REQUEST_METHOD.GET, true),
    cancel: new UrlConfig('/process/free-signatures/cancelation', HTTP_REQUEST_METHOD.POST, true),
  },
  languages: {
    setLanguageExternal: new UrlConfig(
      '/process/{{path}}/language/{{lang}}',
      HTTP_REQUEST_METHOD.POST,
      true
    ),
    setLanguage: new UrlConfig('/process/{{path}}/language/{{lang}}', HTTP_REQUEST_METHOD.POST),
    getLanguage: new UrlConfig('/process/scenario/language', HTTP_REQUEST_METHOD.GET),
    getLanguages: new UrlConfig('/process/scenario/languages', HTTP_REQUEST_METHOD.GET),
  },
};
